import config from '../../constants/config';
import { getCleanUsername } from '../helpers/utils';

export default {
  and: 'et',
  SignUp: 'Inscrivez-vous',
  LogIn: 'Connectez-vous',
  LOGIN: 'CONNECTEZ-VOUS',
  Close: 'Fermer',
  Ok: 'Ok',
  Back: 'Revenir en arrière',
  He: 'Il',
  She: 'Elle',
  Him: 'Lui',
  Her: 'Elle',
  Find: 'Trouver',
  Thanks: 'Merci',
  SingUpLanding: 'Cliquez ici pour trouver',
  LogInLanding: 'Déjà membre? Connectez-vous ici',
  TitleLanding: 'Vous en avez assez des sites de rencontres vieux jeu?',
  SubTitleLanding:
    'Nous aussi! Vivez de nouvelles expériences sur ' +
    config.TITLE +
    ' avec des fonctions comme celles-ci:',
  logInWithApple: 'Connectez-vous via Apple',
  mailIsConfirmed:
    "Félicitations ! Votre compte a été activé avec succès. Merci d'avoir confirmé votre adresse e-mail. Vous pouvez maintenant profiter d'un accès complet à nos services.",
  SignUpWithEmail: "S'inscrire par e-mail",
  reactivateAccount: 'Réactiver le compte',
  welcomeBack: 'Bon retour parmi nous',
  prevYouDeactivYourAcc: 'Vous avez désactivé votre compte antérieurement',
  doUwantToReacYourAcc: 'Voulez-vous réactiver votre compte',
  yesReactivateMyAcc: 'Oui, réactiver mon compte',
  noKeepDeactivated: 'Non, laissez-le désactivé',
  signUpWithApple: 'Inscrivez-vous via Apple',
  TermsOfService: 'Conditions\u00A0de\u00A0service',
  PrivacyPolicy: 'Politique\u00A0de\u00A0confidentialité',
  JoinToday: "Rejoignez-nous aujourd'hui",
  firstName: 'Prénom',
  yourFirstName: 'Veuillez me donner votre prénom',
  EmailAddress: 'Adresse e-mail',
  password: 'Mot de passe',
  EnterEmailAddress: "Saisir l'adresse e-mail",
  EnterPassword: 'Saisir le mot de passe',
  PleaseEnterValidEmail: 'Veuillez saisir une adresse e-mail valide',
  PleaseEnterPassword: 'Veuillez saisir votre mot de passe',
  LandPageHeader: 'Prêt(e) pour une nouvelle aventure?',
  LandPageSubHeader:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) +
    ' site de rencontres met en contact ' +
    config.NICHE_SINGULAR +
    " les célibataires à la recherche d'une romance",
  LandPageLegal: 'En vous connectant, vous acceptez notre',
  LandPageAllDevices: 'Disponible sur tous les appareils',
  ForgotYourPassword: 'Vous avez oublié votre mot de passe?',
  or: 'ou',
  Save: 'Sauvegarder',
  views: 'Visites',
  view: 'Visite',
  ViewedMyProfile: 'Profil visité',
  ViewProfile: 'Visiter le profil',
  UnmatchDelete: 'Rendre incompatible / Supprimer',
  UnmatchDeleteQuestionMark: 'Rendre incompatible/Supprimer?',
  UnmatchDeleteText:
    "Êtes-vous sûr(e) de vouloir les définir comme incompatibles/les supprimer? Vous n'aurez plus accès à l'historique de vos conversations avec ",
  YesUnmatchDelete: 'Oui, rendre incompatible/supprimer',
  IViewed: "J'ai visité",
  ViewedMe: 'A/ont visité mon profil',
  LikesMe: 'Aime mon profil',
  Mutual: 'Mutuel',
  MyLikes: 'Mes likes',
  Chat: 'Clavardage',
  Flirts: 'Flirts',
  Send: 'Envoyer',
  typing: "en train d'écrire",
  UpgradeToVIP: 'Optimiser vers VIP',
  TypeAMessageHere: 'Ecrivez un message ici',
  FeaturesChat:
    config.NICHE_SINGULAR.replace(/\b\w/g, (c) => c.toUpperCase()) + ' Clavardage',
  SendMessagesToWhoYouWant: 'Envoyez des messages à qui vous voulez',
  SeeWhoIsInterestedInYou: "Découvrez qui s'intéresse à vous",
  SeeWhoIsReallyInterestedInYou: "Découvrez qui s'intéresse vraiment à vous",
  IncreaseYourChancesWithAFlirt: 'Augmentez vos chances avec un flirt',
  GetDatesFast: 'Rencardez rapidement en disant Oui ou Non',
  FeaturesIncluded: 'Fonctions incluses',
  Matches: 'Compatibilités',
  Likes: 'Aime',
  QuickMatch: 'Compatibilité Rapide',
  Search: 'Recherche',
  Favorite: 'Favori',
  Favorites: 'Favoris',
  Browse: 'Parcourir',
  MyProfile: 'Mon profil',
  Settings: 'Paramètres',
  // Logout
  LogoutH1: 'Vous vous êtes déconnecté(e) avec succès',
  LogoutP: 'Vous allez nous manquer...',
  LogoutButton: 'Connectez-vous à nouveau',
  // Unsubscribe
  tooManyEmails: "Trop d'emails",
  enterYourEmailBelowToUnsub:
    'Saisissez votre adresse e-mail ci-dessous pour vous désinscrire',
  unsubscribe: 'Se désinscrire',
  unsubscribeSuccess: 'Désinscription réussie',
  youWillNoLongerReceiveAnyEmailFromUs:
    'Vous ne recevrez plus de mails de notre part',
  unSubByAccident: 'Désinscrit(e) par mégard',
  reSubHere: 'Réinscrivez-vous ici',
  helpUsGetBetter: 'Aidez-nous à nous améliorer',
  tellUsWhyYouUnSub: 'Dites-nous pourquoi vous vous êtes désinscrit(e)',
  resubscribeSuccessful: 'Réinscription réussie',
  clickHere: 'Cliquez ici',
  toGoBackToTheSite: 'pour retourner sur le site',
  pleaseSelectOneOfTheReasonsBelow:
    'Veuillez choisir une raison parmi les raisons mentionnées ci-dessous',
  notEnoughUsers: "Pas suffisamment d'utilisateurs",
  complicatedToUse: 'Compliqué à utiliser',
  notEnoughOptions: "Pas suffisamment d'options",
  betterAlternatives: 'Meilleures alternatives',
  badExperienceWithAnotherUser: 'Mauvaise expérience avec un autre utilisateur',
  technicalIssues: 'Problèmes techniques',
  thanksForYourFeedback: "Merci de votre retour d'information",
  tapHere: 'Tapez ici',
  // Who's online
  WhosOnline: 'Qui est en ligne',
  Recent: 'Récemment',
  ThisWeek: 'Cette semaine',
  MembsWereOnlineRec: 'Membres étaient en ligne récemment',
  MembsWereOnlineWeek: 'Membres étaient en ligne cette semaines',
  MembsRecWillAppHere:
    'Les membres qui ont été récemment en ligne apparaîtront ici',
  MembsThisWeekWillAppHere:
    'Les membres qui ont été cette semaine en ligne apparaîtront ici',
  // Browse
  BrowseZero: 'Il y a',
  BrowseZero2: 'des membres',
  BrowseMembersAppear: 'Les membres apparaîtront ici',
  // Favorites
  MyFavorites: 'Mes favoris',
  FavoritedMe: "m'a ajouté à sa liste de favoris",
  YourFavWillAppHere: 'Vos favoris apparaîtront ici',
  MembHaveFavU: 'Membres qui vous ont ajouté à leur liste de favoris',
  MembWhoFavU:
    'Les membres qui vous ont ajouté à leur liste de favoris apparaîtront ici',
  NewPasswordSet:
    'Nouveau mot de passe saisi. Vous pouvez maintenant vous connecter.',
  // Password Recovery
  recoveryTittle: 'Récupération du mot de passe',
  recoveryButton: 'Réinitialiser le mot de passe',
  goBackToLogIn: "Retour à la page d'accueil",
  recoveryMessage1:
    'Si nous trouvons un compte avec cette adresse e-mail, la récupération du mot de passe sera envoyée.',
  NewPassword: 'Nouveau mot de passe',
  SetNewPassword: 'Saisir un nouveau mot de passe',
  // Info Line
  NotShared: 'Non partagée',
  // Create Account Email Register
  byCreatingYourAccount:
    "En m'inscrivant sur le site, j'accepte les conditions de ",
  alsoAgree:
    "J'accepte également de recevoir des messages, des mises à jour de mon compte et des offres spéciales par e-mail",
  picturesDisclaimer:
    'Les photos sont utilisées en guise d’exemples uniquement et toute personne représentée dans le contenu est un modèle',
  step: 'Etape',
  // GenderStep
  StepsTitle:
    'Rejoignez-nous et faites des rencontres ' +
    (config.NICHE_SINGLES
      ? config.NICHE_SINGLES
      : config.NICHE_PLURAL.replace(/\b\w/g, (c) => c.toUpperCase())) +
    ' maintenant!',
  gender: 'Sexe',
  startMeeting: 'Commencez à faire des rencontres maintenant',
  weNeedInfo: 'Nous avons juste besoin de quelques informations',
  iAm: 'Je suis un/une:',
  near: 'Près de:',
  seeking: "A la recherche d'un/d'une:",
  next: 'Suivant',
  viewOtherOptions: "Voir d'autres options",
  // LocationStep
  location: 'Localisation',
  WhereAreYouLocated: 'Où êtes-vous situé(e)?',
  WellFindMatchesInYourArea:
    'Nous vous trouverons des personnes compatibles dans votre secteur',
  EnterYourCityOrLocation: 'Veuillez saisir votre ville ou localisation:',
  // AgeStep
  age: 'Âge',
  howOldAreYou: 'Quel âge avez-vous?',
  enterAgeBelow: 'Saisissez votre âge ci-dessous',
  ageLabel: 'Âge:',
  agePlaceholder: 'Votre âge',
  ageError: 'Âge doit être compris entre < et >',
  EnterYourAge: 'Saisissez votre âge:',
  // UsernameStep
  username: "Nom d'utilisateur;",
  chooseUsername: "Choisissez un nom d'utilisateur",
  itWillBeYourBio: 'Il sera utilisé dans votre profil',
  usernamePlaceholder: 'Example: ' + getCleanUsername(config.NICHE_SINGULAR),
  chooseAUsername: "Choisissez un nom d'utilisateur",
  usernameError: "Ce nom d'utilisateur n'est pas valide",
  usernameLabel: "Nom d'utilisateur",
  usernameLabelSmall: '(6-14 lettres et chiffres)',
  // EmailStep
  emailPassword: 'E-mail/Mot de passe',
  youAreDone: 'Vous y êtes presque...',
  createYourAccount: 'Créez votre compte ci-dessous',
  createAccount: 'Créer un compte',
  emailError: 'Veuillez saisir une adresse e-mail valide',
  passwordError: 'La longueur minimale du mot de passe est de 6 caractères',
  ageMissingHeadline: "Demande d'âge",
  EnterYourEmailAddress: 'Saisissez votre adresse e-mail',
  RemainsConfidential: '(demeure confidentiel)',
  ChooseAPassword: 'Choisissez un mot de passe',
  Min6Car: '(min. 6 caractères)',
  itWiilBeUsedForLogin: 'Il sera utilisé pour la connexion',
  // PasswordStep
  choosePassword: 'Choisissez un mot de passe',
  // EmailAndPasswordStep
  enterEmailAndPassword: 'Entrez votre e-mail et choisissez un mot de passe',
  // Auto-complete
  EnterYourLocation: 'Saisissez votre localisation',
  EnterYourCityOrZipCode:
    'Saisissez votre ville ou votre code postal ci-dessous:',
  enterCityOrZip: 'Saisissez votre ville ou votre code postal:',
  Menu: 'Menu',
  More: 'Davantage',
  // Compatibiltés
  noMatchesFound: 'Aucune compatibilité trouvée',
  wantMoreMatches: 'Envie de plus de compatibilités?',
  tapButtonBelow:
    'Cliquez sur le bouton ci-dessous pour modifier vos préférences en matière de compatibilités',
  editMatchPreferences: 'Modifier les préférences',
  // MyLikes
  youHave: 'Vous avez',
  increaseYourMatches:
    'Augmentez vos compatibilités en cliquant sur le bouton "Commencez à liker" ci-dessous',
  startLiking: 'Commencez à liker',
  // Mutual
  mutualLikes: 'Likes mutuels',
  // LikesMe
  membersHaveLikedYou: 'Membres vous ont liké',
  // MyViews
  youHaveViewed: 'Vous avez visité',
  profiles: 'Profils',
  membersWhoYouViewed:
    'Les membres qui ont visité votre profil vont apparaître ici',
  // ViewedMe
  memberViewedYou: 'Membres ont visité votre profil',
  memberWhoViewYourProfile:
    'Les membres qui ont visité votre profil apparaîtront ici',
  // Settings
  logout: 'Déconnexion',
  general: 'général',
  account: 'compte',
  legal: 'autorisé',
  support: 'assistance',
  matchPref: 'Préférences de compabilités',
  emailPref: "Préférences d'e-mail",
  privacyStgs: 'Paramètres de confidentialité',
  reactivateVipMbership: "Réactiver l'abonnement VIP",
  youAreVipMember: 'Vous êtes un(e) membre VIP',
  byCancelingYourVip:
    "En annulant votre abonnement VIP, vous n'aurez plus accès aux fonctions suivantes après l'expiration de votre abonnement actuel",
  unLimitedMessages: 'Messages illimités',
  seeAllPhotos: 'Voir toutes les photos',
  unlimtedUndo: 'Annulations du dernier mouvement illimitées',
  deactivateAccount: 'Désactiver le compte',
  deleteAccount: 'Supprimer le compte',
  showMe: 'Montrez-moi',
  limitSearchToDistance: 'Limiter la recherche à  la distance',
  showAges: "Montrer les tranches d'âge",
  men: 'Hommes',
  women: 'Femmes',
  toastPrefUpdatedSucc: 'Préférences mises à jour avec succès',
  receiveEmail: 'Recevoir un e-mail',
  whenSomebodySendsNewMsg: "Lorsque quelqu'un m'envoie un nouveau message",
  whenSomebodyLikesMe: "Lorsque quelqu'un m'a liké",
  whenSomebodyVisitMyPof: "Lorsque quelqu'un a visité mon profil",
  whenNewMembersComeOnline: 'Lorsque de nouveaux membres sont en ligne',
  withDiscountPromotions: 'Avec des promotions à prix réduit',
  notifOptions: 'Options de notification',
  notifUpdateSucc: 'Notifications mises à jour avec succès',
  privacySettingsText1: 'Contrôlez qui voit votre profil',
  privacySettingsText2: 'Choisissez une ou plusieurs options ci-dessous',
  importantNotice: 'Avis important',
  byDeactivatingYourAccount:
    "En désactivant votre compte, vous n'aurez plus accès aux éléments suivants jusqu'à ce que vous réactiviez votre compte",
  yourMatches: 'Vos compatibilités',
  yourMessages: 'Vos messages',
  yourLikes: 'Vos likes',
  yourFavorites: 'Vos favoris',
  allOtherInfo: 'Toute autre renseignement relatif à votre compte',
  yourProfileWillBeHidden:
    "Votre profil sera caché aux autres membres. Vous ne recevrez plus de mails de notre part tant que vous n'aurez pas réactivé votre compte. Cliquez sur le bouton ci-dessous pour désactiver votre compte",
  areYouSure: 'Êtes-vous sûr(e)',
  yourAccountWillBeDeact: 'Votre compte sera désactivé',
  yesDeactivateAcc: 'Oui, désactivez mon compte',
  accountSuccDeact: 'Compte désactivé avec succès',
  byDeletingYourAccount:
    'En supprimant votre compte, les informations suivantes seront définitivement effacées',
  infoUsedToCreate: 'Informations utilisées pour la création de votre compte',
  yourPhotos: 'Vos photos',
  yourChatHistory: "L'historique de vos clavardages",
  thisActionIsNotReversible: 'Cette action est irréversible',
  tapTheButtonBellow:
    'Cliquez sur le bouton ci-dessous pour supprimer votre compte',
  yesDeleteAccount:
    "Oui, supprimez mon compte',Unterminatedi-dessous pour consulter les données de votre compte",
  accountSuccDelete: 'Compte supprimé avec succès',
  byReactivatingYourVip:
    'En réactivant votre abonnement VIP, vous serez facturé à la fin de la période de facturation en cours',
  tapTheButtonToReactivateVip:
    'Appuyez sur le bouton ci-dessous pour réactiver votre adhésion VIP',
  yourMembershipWillExpire: 'Votre adhésion expirera le',
  yourMembershpWillRenew: 'Votre adhésion sera renouvelée le',
  yourVipMembershipWillReactivate: 'Votre adhésion VIP sera réactivée',
  yesReactivateVip: "Oui, réactiver l'adhésion VIP",
  noIveChangedMyMind: "Non, j'ai changé d'avis",
  membershipSuccessfullyReactivated: 'Adhésion réactivée avec succès',
  membershipSuccessfullyCanceled: 'Adhésion annulée avec succès',
  visibilityPreferences: 'Préférences de visibilité',
  onlyShowMyProfileToPeopleISendMsg:
    "Afficher mon profil uniquement aux personnes à qui j'envoie des messages",
  dataManagement: 'Gestion des données',
  tapTheDownloadDataButtonBelowToViewYourAccountData:
    'Appuyez sur le bouton « Télécharger les données » ci-dessous pour afficher les données de votre compte',
  downloadData: 'Télécharger les données',
  yesDownload: 'Oui, Télécharger',
  yourDataWillBeDownloaded: 'Vos données seront téléchargées',
  changePassword: 'Changer le mot de passe',
  saveChanges: 'Enregistrer les modifications',
  currentPassword: 'Mot de passe actuel',
  confirmNewPassword: 'Confirmer le nouveau mot de passe',
  enterNewPassword: 'Entrez un nouveau mot de passe',
  passwordNotMatch: 'Le mot de passe ne correspond pas',
  passwordChangedSuccess: 'Mot de passe modifié avec succès',
  registredAs: 'Enregistré comme:',
  userID: 'ID utilisateur:',
  version: 'Version:',
  // Member
  cancel: 'Annuler',
  reportUser: "Rapport d'utilisateur",
  blockUser: "Bloquer l'utilisateur",
  options: 'Options',
  startConversation: 'Démarrez une conversation',
  requestPhotoTap: 'Cliquez ici',
  requestPhotoTapTo: 'pour lui demander sa photo',
  requestPhotoTapToFemale: 'pour lui demander sa photo',
  requestPhoto: 'pour demander une hoto',
  photoAlreadyRequested: 'Photo déjà requise',
  youAlreadyRequestedPhoto:
    'Vous avez déjà demandé la photo de cet utilisateur',
  photoRequestSuccessfully: 'Photo requise avec succès',
  tellWhy: 'Expliquez-nous pourquoi',
  inappropriatePhotos: 'Photos inappropriées',
  inappropriateMessages: 'Messages inappropriés',
  badOfflineBehavior: 'Mauvais comportement hors ligne',
  feelsLikeSpam: 'Ressemble à du spam',
  other: 'Autre',
  report: 'Signaler',
  reportComment: 'Signaler le commentaire...',
  blockMember: 'Bloquer ce membre?',
  willNoLongerAppear:
    "n'apparaîtra plus dans votre liste de personnes compatibles.",
  yesBlock: 'Oui, bloquez ce membre',
  noCancel: 'Non, annulez',
  userReportedSuccessfully: 'Utilisateur a signalé avec succès',
  userBlockedSuccessfully: 'Utilisateur bloqué avec succès',
  addedToFavorites: 'Ajouté à la liste de favoris!',
  removedFromFavorites: 'Retiré de la liste de favoris!',
  sendAMessage: 'Envoyez un message',
  sendUserAMessage: 'Envoyez à {user} un message',
  wellYouveComeThisFar:
    'Eh bien, après avoir fait tout ce chemin, vous pourriez aussi bien dire quelque chose',
  chatWith: 'Clavardez avec',
  outOfFlirts: 'À court de lirts',
  untilYouCanSend: "Jusqu'à ce que vous puissiez envoyer un flirt à nouveau.",
  wantToMakeSure: 'Vous voulez être sûr(e)',
  seesYou: "qu'il/elle vous voit?",
  goVipGetFlirts: 'Passez en VIP et obtenez {num_of_flirts} flirts par jour!',
  getMoreFlirts: 'Obtenez plus de flirts',
  noNotThisTime: 'Non, pas pour le moment',
  flirtSent: 'Flirt envoyé et apprécié',
  memberNotSharedAboutMe:
    "Ce membre n'a pas partagé les renseignements sur lui",
  dontWait: "N'attendez pas",
  chooseFlirt: 'Choisissez un flirt:',
  sendFlirt: 'Envoyez un flirt',
  flirtIsSent: 'Flirt est envoyé',
  // Chats
  chats: 'Clavardages',
  sentMessages: 'Messages envoyés',
  yourConversations:
    'Vos conversations avec les autres membres apparaîtront ici',
  yourSentMessages: "Vos messages envoyés à d'autres membres apparaîtront ici",
  // ChatRoom
  cannotSendMessageUnlessVip:
    'Vous ne pouvez pas envoyer de messages via clavardage à moins que vous ne soyez un utilisateur VIP ou que la fonction "Happy Hour" soit activée',
  happyHour: 'Happy Hour',
  sendMessagesFree: 'Envoyez des messages gratuitement',
  endsIn: 'Prend fin dans:',
  happyHourTonightAt: 'Ce soir à ',
  happyHourTodayAt: "Aujourd'hui à ",
  // Contact us
  ContactUs: 'Nous\u00A0Contacter',
  ContactUsSupport: 'Contactez-nous / Assistance',
  WhatIsYourEmail: 'Quelle est votre adresse e-mail?',
  HowCanWeHelpU: 'Que pouvons-nous faire pour vous aider?',
  WriteMsg: 'Ecrivez un message...',
  SendMsg: 'Envoyez un message',
  EnterMsg: 'Saisissez un message.',
  AlertMsgSentSuccessfully: 'Merci! Le message est envoyé avec succès.',
  ToastMsgSentSuccessfully: 'Message envoyé avec succès',
  Subject: 'Sujet',
  subject0: 'Questions générales',
  subject1: 'Abonnement VIP',
  subject2: 'Signaler une fraude',
  subject3: 'Annulation',
  subject4: 'Supprimer le compte',
  subject5: 'Autre',
  // Search
  refineSearch: 'Affiner la recherche',
  iamDoneRefining: "J'ai fini d'affiner",
  showAdvanced: 'Afficher les options avancées',
  hideAdvanced: 'Cacher les options avancées',
  cancelSearch: 'Annuler la recherche affinée?',
  youWillLoseYourChanges:
    'Vous perdrez toutes les modifications apportées à vos critères de recherche',
  yesLeavePage: 'Oui, quittez la page',
  noContinueRefining: 'Non, continuez à affiner',
  zeroMembersFound: 'Membres trouvés',
  tap: 'Cliquez',
  // tapHere: 'Cliquez ici',
  // uploadAPhotoHere: 'Téléversez une photo ici',
  toDisplayPreviousMembers: 'pour afficher les membres précédents.',
  toEditCurrentFilters: 'pour modifier les filtres actuels.',
  resetSearch: 'Réinitialiser la recherche',
  tryAgain: 'Essayez de nouveau',
  mile: 'Mile',
  miles: 'Miles',
  noUsers: 'Aucun utilisateur',
  // Quick Match Button text
  undo: 'Annulation du dernier mouvement',
  pass: 'Ignorer',
  like: 'Liker',
  profile: 'Profil',
  undoNotAvailable: "Annulation du dernier mouvement n'est pas disponible",
  nothingToUndo: "Il n'y a rien à annuler.",
  thisIsTheFirstUser: " C'est le premier utilisateur.",
  dismissAd: 'Rejeter',
  seeMoreHere: 'Voir plus ici',
  tryChangingYourPreferences: 'Essayez de modifier vos préférences.',
  errorOnInviteActionTitle: 'Erreur sur Compatibilité Rapide',
  // It's Match
  itsMutual: "C'est mutuel",
  youAndMemberLikeEachOther:
    'Vous et {member}, vous vous plaisez mutuellement!',
  seeMoreMatches: 'Voir plus de compatibilités',
  // My Profile
  edit: 'Modifier',
  aboutMe: 'A propos de moi',
  youHaveNotSharedAbout:
    'Vous n\'avez encore rien partagé sur "A propos de moi"',
  appearance: 'Apparence',
  situation: 'Situation',
  addPhoto: 'Ajouter la photo de profil',
  // Edit Profile
  editProfile: 'Modifier le profil',
  reset: 'Réinitialiser',
  dob: 'Date de naissance',
  youWillLoseYourChangesProfile:
    'Vous perdrez toutes les modifications que vous avez apportées à votre profil',
  cancelEdit: 'Annuler la modification du profil?',
  noContinueEditing: 'Non, continuez à modifier',
  invalidMonth: 'Mois non valide',
  invalidDay: 'Jour non valide',
  invalidAge: 'Vous devez avoir entre {min} et {max} ans',
  invalidFebruar: 'Le mois de février peut avoir au maximum 28 ou 29 jours',
  invalid30Day: 'Ce mois peut avoir au maximum 30 jours',
  invalid31Day: 'Ce mois peut avoir au maximum 31 jours',
  invalidLocation:
    "Cette localisation n'est pas valide, veuillez sélectionner la localisation depuis le menu déroulant",
  locationUpdated: 'Localisation mise à jour avec succès',
  setAsMainPhoto: 'Définir comme photo principale',
  changeAsMainPhoto: 'Changer en photo principale',
  deletePhoto: 'Supprimer la photo',
  areSureDeletePhoto: 'Êtes-vous sûr(e) de vouloir supprimer cette photo?',
  noKeepPhoto: 'Non, gardez la photo',
  yesDeletePhoto: 'Oui, supprimez la photo',
  editPhoto: 'Editer la photo',
  profileUpdated: 'Profil mis à jour avec succès',
  secondaryImageAlertText:
    'Cette image est considérée comme secondaire par le service clientèle et ne peut donc pas être utilisée comme photo de profil.',
  reviewImageAlertText:
    "Cette image n'est pas encore approuvée par notre service clientèle, veuillez essayer plus tard.",
  pendingReview: 'En attente de révision',
  // missing location
  locationReq: 'Demande de localisation',
  pleaseEnterLocation: 'Veuillez saisir votre localisation ci-dessous.',
  withoutItOther: 'Sans elle, les autres membres',
  cantSee: 'ne peuvent vous voir,',
  likeOrMessage: 'vous liker, ou vous envoyer un message.',
  submit: 'Soumettre',
  // missing username
  completeYourProfile: 'Complétez votre profil',
  itWillBeUsedOnYourProfileBio:
    'Il sera utilisé dans la biographie sur votre profil',
  userNameLettersAndNumbers: '(6-14 lettres et chiffres)',
  submitUsername: "Soumettre un nom d'utilisateur",
  unknownError: "Une erreur inconnue s'est produite",
  confirmUsername: "Confirmez le nom d'utilisateur",
  orChooseNewOne: 'Ou choisissez un autre',
  // missing username and location
  welcomeToSite: 'Bienvenue à ' + config.TITLE,
  yourAccountIsNowActive: 'Votre compte est maintenant activé!',
  itsGreatToHaveYou:
    'Nous sommes heureux de vous compter parmi les membres de notre site et nous avons hâte de vous aider à trouver une compatibilité\u00A0parfaite.',
  // error
  somethingWentWrong: 'Quelque chose a mal tourné',
  networkError: 'Erreur de réseau! Veuillez réessayer plus tard.',
  // invalid Token
  invalidToken: 'Votre session a expiré. Veuillez vous connecter à nouveau',
  // rejected Username
  rejectedUsername: "Nom d'utilisateur rejeté",
  // missing password
  missingPassword: 'Vous y êtes presque...',
  missingPasswordText: 'Définissez votre mot de passe ci-dessous',
  missingPasswordPlaceholder: '6 caractères au minimum',
  submitPassword: 'Définir le mot de passe',
  // missing email
  missingEmail: 'Votre adresse e-mail manque',
  missingEmailText:
    'Saisissez votre adresse e-mail ci-dessous pour recevoir des notifications lorsque vous avez de nouveaux messages, des likes, des compatibilités et lorsque nos membres consultent votre profil.',
  submitEmail: 'Soumettre une adresse e-mail',
  // Move and Scale
  moveAndScale: 'Déplacer et réduire',
  crop: 'Recadrer',
  uploadError: "Erreur de téléversement d'image",
  whoops: 'Oups',
  itSeemsThatIsTaking:
    "Il semble que le téléversement de la photo prenne plus de temps que d'habitude. Veuillez réessayer.",
  // Missing Photo
  photoRequest: 'Demande de photo',
  wait: 'Patientez...',
  yourMissingPhoto: 'Votre photo manque',
  membersWithoutPhotos: 'Les membres sans photo ont 65% moins de chances',
  likelyToReceive: 'de recevoir des likes et des messages',
  submitPhoto: 'Soumettre une photo',
  takePhoto: 'Se prendre en photo',
  chooseFromLibrary: 'En choisir dans la photothèque',
  // Missing Gender
  youLookingFor: 'Que cherchez-vous',
  // Explicit Opt in Modal
  youAreAlmostDone: 'Vous y êtes presque...',
  iWouldLikeToGetSpecOffers:
    'Je souhaite recevoir des offres spéciales, des remises exceptionnelles et des ventes mensuelles par e-mail',
  iHaveReadAndAgreeToPP: "J'ai lu et j'accepte les conditions de",
  ByJoiningTheSiteAgreeTos: "En m'inscrivant sur le site, j'accepte le/la/les",
  optional: 'Facultatif',
  required: 'Requis(e)',
  continue: 'Continuer',
  // coreg
  toGetStarted: 'Pour démarrer',
  tapHereToGetStarted: 'Cliquez ici pour démarrer',
  hello: 'Coucou',
  // Upgrade Modal
  membershipStatus: 'Statut de membre',
  upgradeToVipChoosePlan: 'Optimiser vers VIP.',
  wantUnlimitedMessages: 'Voulez-vous des messages illimités?',
  wantToReply: 'Envie de répondre à %gender%? Passez en VIP!',
  getUnlimitedMessages:
    'Obtenez des messages illimités. Choisissez la formule:',
  needToUndoMistake:
    "Besoin d'annuler le dernier mouvement commis par erreur? Passez en VIP!",
  getUnlimitedUndos:
    'Obtenez les annulations du dernier mouvement en illimité - Choisissez la formule:',
  whoViewedYourProfile: 'Qui a visité votre profil? Découvrez-le!',
  peopleViewedYourProfile: 'Personne(s) a/ont visité votre profil',
  chooseVipPlanToSeeThem:
    'Choisissez la formule VIP and découvrez qui sont ces personnes:',
  wantToSeeWhoFavoritedYou:
    'Envie de voir qui vous a ajouté à sa liste de favoris?',
  peopleFavoritedYou:
    'Personne(s) vous a/ont ajouté à sa/leur liste de favoris',
  wantToSeeWhoLikesYou: 'Envie de voir qui vous a liké?',
  peopleLikedYou: 'Personne(s) vous a/ont liké',
  youAreBasic: 'Vous êtes un membre de base',
  wantToUnlockPhotos: 'Envie de débloquer toutes les photos?',
  wantMoreFlirts: 'Souhaitez-vous avoir 5 flirts par jour?',
  vipMembershipFeatures:
    "L'abonnement premium VIP comprend les fonctions suivantes:",
  vipMembershipFeaturesMobile: 'Les membres VIP obtiennent:',
  unlimited: 'La messagerie',
  messaging: 'illimitée',
  meetSomeoneTonight: 'Optimisez maintenant - Faites des rencontres ce soir!',
  chooseVipPlanBelow: 'Choisissez la formule VIP ci-dessous:',
  messagingSub: 'Continuez à clavarder avec vos compatibilités',
  viewedSub: 'Découvrez qui a visité votre profil',
  likesMeSub: 'Découvrez qui a liké votre profil',
  unlockPhotosSub: 'Consultez toutes les photos des utilisateurs',
  favoritedMeSub: "Découvrez qui s'intéresse vraiment à vous",
  moreFlirtsSub: 'Augmentez vos chances avec 5 flirts par jour',
  goPrivateSub: 'Contrôlez qui voit votre profil',
  undoSub:
    'Vous avez commis une erreur? Annulez le dernier mouvement par simple glissement du doigt!',
  select: 'Sélectionner',
  vipMembersReceive: 'LES MEMBRES VIP OBTIENNENT:',
  chooseYourPlan: 'CHOISISSEZ VOTRE FORMULE:',
  enterPaymentDetails: 'ENTREZ LES DÉTAILS DE VOTRE PAIEMENT:',
  creditCard: 'Carte de crédit',
  yourSubscriptionWillRebill:
    "Votre abonnement sera automatiquement refacturé à un abonnement {0} à {1} le {2} et renouvelé tous les {0} jusqu'à ce qu'il soit annulé. Vous pouvez annuler votre abonnement à tout moment, via les paramètres de votre compte.",
  byTappingButtonBelow:
    'En cliquant sur le bouton ci-dessous, vous acceptez le/la/les',
  andAuthorizeToCharge:
    'et nous autorisent à débiter votre %CARD_TYPE% maintenant et à chaque renouvellement.',
  continueToPayPal: 'Continuez vers PayPal pour compléter votre achat.',
  proceedToPayPal: 'Procédez au paiement via PayPal',
  limitedTimeOffer: 'Offre à durée limitée',
  promoHeader: "{date} d’essai de l'abonnement VIP pour {price}",
  promoHeaderNoTrial: '{price} / {rebill_period} mois',
  promoSubHeaderText:
    "Il s'agit d'une offre unique et exclusive pour les nouveaux membres",
  promoButtonText: "Uniquement {price} - {date} d'essai",
  promoRebillsText:
    "*Refacturation tous les {date} pour {price} si l'abonnement VIP n'est pas annulé avant la fin de la période d'essai*",
  accessToAllPhotos: "L'accès à toutes les photos est disponible",
  toPremiumUsers: 'uniquement à tous les utilisateurs Premium.',
  unlimitedMessaging: 'Messagerie illimitée est disponible',
  upgradeTodayAndSendMessage:
    "Mettez à niveau aujourd'hui pour lire et répondre aux messages de",
  upgradeTodayAndSeePhotos:
    "Optimisez dès aujourd'hui pour accéder à toutes les photos de",
  mostPopular: 'plus populaires',
  notSuitableForCreditCard: 'Vous ne pouvez pas payer par carte de crédit?',
  weAreAccepting: 'Nous acceptons ',
  payPal: 'PayPal',
  // Welcome Back Modal
  weHaveAnOffer: 'Nous avons une offre pour vous:',
  discount: 'remise',
  onVipMembership: "sur l'abonnement VIP!",
  tapHereToSave: 'Cliquez ici pour économiser 50%!',
  toUnlockFeatures: 'pour débloquer toutes les fonctions Premium',
  upgrade: 'Optimiser',
  upgradeNow: 'Optimisez maintenant',
  // Invalid Tagline
  invalidTaglineHeadline: 'Description rejetée',
  invalidTaglineTitle:
    'Le texte dans la rubrique "A propos de moi" n\'a pas été approuvé.',
  invalidTaglineReason: 'Raison: ',
  invalidTaglineButton: 'Mettre la description à jour',
  // Invalid Tagline
  photoRejectedHeadline: 'Photo refusée',
  photoRejectedTitle: 'Nous sommes désolés...',
  photoRejectedParagraph:
    "Une ou plusieurs de vos photos téléversées n'ont pas été approuvées.",
  photoRejectedReason: 'Raison: ',
  photoRejectedButton: 'Soumettre une nouvelle photo',
  viewed: 'Consultée',
  myProfile: 'Mon profil',
  unlock: 'Débloquer',
  allPhotos: 'Toutes les photos',
  undos: 'Annulation(s) du dernier mouvement',
  moreFlirts: 'Plus de flirts',
  goPrivate: 'Aller en privé',
  monthFor: 'Mois',
  monthsFor: 'Mois',
  mo: 'mois',
  month: 'mois',
  months: 'mois',
  monthly: 'mensuellement',
  billed: 'facturé',
  every: 'tous les',
  saveUpTo: "Economisez jusqu'à",
  trialFor: 'Essai pour',
  day: 'jour',
  days: 'Jours',
  free: 'gratuitement',
  trialRebillsAt: "l'essai est refacturé à",
  per: 'par',
  best: 'Meilleur',
  value: 'Rapport qualité-prix',
  // Checkout
  planSelected: 'Plan choisi',
  paymentOption: 'Option de paiement',
  billingDetails: 'Détails de facturation',
  payByCard: 'Payer par carte',
  creditOrDebitCard: 'Payez par carte de crédit ou de débit',
  payWith: 'Payez par',
  pay: 'Pay',
  pal: 'Pal',
  for: 'pour',
  promoRebillsAt: 'remises promotionnelles à',
  chooseMembershipPlan: "Choisissez votre plan d'abonnement ci-dessous",
  choosePaymentOption: 'Choisissez votre option de paiement ci-dessous',
  enterCardDetails: 'Saisissez les données de votre carte de crédit ci-dessous',
  nameOnCard: 'Nom du détenteur',
  enterFullName: 'Saisissez votre nom et prénom ici',
  creditCardNumber: 'Numéro de carte de crédit',
  cardNumber: 'Numéro de carte',
  expirationDate: "Date d'expiration",
  cvv: 'Code de sécurité CVV',
  pleaseEnterCvv: 'Veuillez saisir le code CVV',
  forYourPrivacyYouAreBilled:
    'Par respect pour votre vie privée, vous êtes facturé(e) discrètement en tant que',
  byCompletingThisTransaction:
    'En effectuant cette transaction, vous certifiez que vous avez au moins 18 ans et que vous acceptez les conditions suivantes',
  submitAndUpgrade: 'Soumettre et optimiser vers VIP',
  thisIsSecurePage: 'Cette page est sécurisée.',
  dataTransferIsEncrypted:
    'Le transfert des données est crypté pour des raisons de sécurité et de protection',
  tellUsYourFullName: 'Indiquez votre nom complet (par ex. Jean Dupont)',
  pleaseEnterYourCreditCard:
    'Veuillez saisir le numéro de votre carte de crédit',
  pleaseEnterValidCreditCard:
    'Veuillez saisir un numéro de carte de crédit valide',
  pleaseEnterMonth: 'Veuillez saisir le mois',
  pleaseEnterValidMonth: 'Veuillez saisir un mois valide',
  pleaseEnterYear: "Veuillez saisir l'année",
  pleaseEnterValidCvv: 'Veuillez saisir un code CVV valide',
  pleaseAgreeToTos: "Veuillez accepter les conditions d'utilisation",
  thanksForBeingVip: "Merci d'être un(e) membre VIP",
  subscriptionUnavailable:
    "L'abonnement n'est pas disponible car vous êtes déjà VIP",
  onTheBackOfCard: 'Au dos de votre carte, vous pouvez',
  findYour: 'trouver votre',
  cvvCvc: 'code CVV/CVC',
  codeHere: 'ici.',
  hurryUp: 'Dépêchez-vous!',
  thisOfferExpires: 'Cette offre expire dans:',
  youAreInLuck: 'Vous avez de la chance!',
  thisPromoGotExtended:
    'Cette promotion a été prolongée. Saisissez-la rapidement, car nous pouvons la retirer à tout moment maintenant.',
  forYour: 'Par respect pour votre',
  privacy: 'vie privée',
  youAreBilled: 'vous serez facturé(e)',
  discreetly: 'discrètement',
  as: 'en tant que',
  specialOffer: 'Offre spéciale',
  membershipInfo: "Infos sur l'abonnement",
  // Success Upgrade
  successUpgrade: 'Optimisation réussie',
  welcomeToVip: 'Bienvenue à VIP!',
  youHaveSuccessfullyUpgraded: 'Vous avez optimisé avec succès vers',
  vipPremiumMembership: "l'abonnement VIP Premium",
  importantInfo: 'Information importante!',
  pleasePrintThisPage:
    "Veuillez imprimer cette page ou noter les informations suivantes. Vous en aurez besoin à l'avenir pour accéder à vos renseignements de membre ou pour les modifier.",
  yourCreditCardBilled:
    'Votre carte de crédit/débit sera discrètement facturée en tant que',
  yourPayPalCardBilled:
    'Votre compte PayPal sera discrètement facturé en tant que',
  youWillBeDicreetlyBilled: 'Vous serez discrètement facturé(e) en tant que:',
  membershipPurchased: 'Abonnement acquis:',
  billingTerms: 'Modalités de paiement:',
  vipPremium: 'VIP Premium',
  total: 'Total',
  vip: 'VIP',
  trial: 'Essai',
  yourInfo: 'Vos renseignements:',
  fullName: 'Nom et prénom:',
  pleaseContactSupport:
    'Veuillez contacter le service clientèle si vous avez des questions concernant la facturation',
  billingSupport: 'Assistance à la facturation:',
  billingPhone: 'Numéro de téléphone de facturation:',
  clickToAccessVip: 'Cliquez pour accéder aux fonctions VIP',
  tapToAccessVip: 'Cliquez sur la touche pour accéder aux fonctions VIP',
  thirtyDays: '30 jours',
  // Process Payment
  processPayment:
    'Veuillez patienter, nous traitons votre demande de paiement...',
  paymentProcessingError: 'Erreur de traitement des paiements!',
  // Error Component
  serviceUnavailable: 'Service temporairement indisponible',
  pleaseTryLater: 'Veuillez réessayer plus tard',
  // Another Client
  isOpenInAnotherWindow:
    'est ouvert dans une autre fenêtre. Vous pouvez fermer cette fenêtre.',
  useInThisWindow: 'Utilisez dans cette fenêtre',
  // modal alert merging
  greatNews: 'Bonnes nouvelles,',
  weAreHappy:
    " Nous sommes heureux de vous annoncer qu'à partir d'aujourd'hui, ",
  become: '{old_site} et {new_site} sont devenus un grand site: {new_site}! ',
  thisMeans:
    " Cela signifie une plus grande communauté pour tous nos membres, plus de compatibilités et une plus grande chance de trouver quelqu'un de spécial.",
  dontWorry:
    'Ne vous inquiétez pas, pour vous, en tant que membre, rien ne change. Vos informations de connexion, vos renseignements de profil et votre historique ont été transférés automatiquement, vous pourrez donc continuer là où vous étiez au moment de la fin de la session. ',
  // ads
  ad: 'Pub',
  sponsored: 'PARRAINEE',
  findNiche:
    'Trouvez ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  meetNiche:
    'Rencontrez ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  // ads random text, this is generated like this for easy transition to another niche
  adsRandomTextMeetNiche:
    'Rencontrez ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSingleNiche:
    'Célibataire ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextFindNiche:
    'Trouvez ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextDateNiche:
    'Rencardez ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheRomance:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Romance',
  adsRandomTextLonelyNiche:
    'Seul(e) ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheLove:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' Amour',
  adsRandomTextWhantNiche:
    'Envie de ' +
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) +
    '?',
  adsRandomTextNicheDates:
    config.NICHE_SINGULAR.replace(/\w/, (c) => c.toUpperCase()) + ' rencontres',
  adsRandomTextMoreNiche:
    'Plus ' + config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextSearchNiche:
    'A la recherche ' +
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()),
  adsRandomTextNicheNow:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Maintenant?',
  adsRandomTextNichesingles:
    config.NICHE_PLURAL.replace(/\w/, (c) => c.toUpperCase()) + ' Célibataires',
  // niche gender names
  genderTsTvTg: 'Trans/Travesti/Transgenre',
  genderXdresser: 'Traves\u00ADti',
  genderCouple: 'Couple',
  genderDom: 'Dominatrice',
  genderFem: 'Domination féminine',
  genderBiCouple: 'Couple bissexuel',
  genderSugarMale: 'Sugar boy',
  genderSugarBaby: 'Lolita',
  genderHotWife: 'Epouse infidèle/\n\u00ADCouple',
  genderMan: 'Homme',
  lookingFor: "à la recherche d'une",
  genderMilf: 'femme MILF',
  // onboarding
  moreInformation:
    "Donnez-nous un peu plus d'informations sur vous afin de trouver d'autres célibataires qui vous correspondent",
  howTallAreYou: 'Combien mesurez-vous?',
  UseSliderHeight: 'Utilisez le curseur pour préciser votre hauteur',
  WhatIsYourEthnicity: 'Quelle est votre appartenance ethnique?',
  specifyYourBodyType: 'Veuillez préciser votre type de silhouette',
  whatYouLookingFor: 'Parlez-nous de votre partenaire idéal',
  idealMatchesAge: "Quel est l'âge idéal de vos compatibilités",
  howFarAway:
    'Quelle distance seriez-vous prêt(e) à parcourir pour rencontrer votre partenaire idéal(e)?',
  useSliderDistance: 'Utilisez le curseur pour préciser la distance',
  toHaveYourProfile: 'Parlez de vous aux autres membres...',
  writeSomethingAboutYourself:
    "Écrivez quelque chose d'intéressant sur vous-même, quelque chose qui vous décrit le mieux",
  uploadAPhoto: 'Téléverser une photo',
  thisIsImportant: 'Ceci est la fonction la plus importante de votre profil!',
  youOnlyHave:
    "Vous n'avez qu'une seule chance de faire une bonne première impression.",
  tipPhoto:
    'Tip: Les photos doivent être récentes, ne comporter que vous et mettre en valeur vos meilleures qualités pour obtenir les meilleurs résultats possibles!',
  iUploadLater: 'Je vais téléverser une photo plus tard..',
  congratulations: 'Félicitations...',
  yourProfileUpdated:
    'Votre profil a été mis à jour et vous êtes sur le point de trouver votre partenaire idéal(e).',
  specialOfferNewMembers:
    "En guise d'offre spéciale pour les nouveaux membres, nous vous offrons 25% de remise sur le prix normal de l'abonnement.",
  get25OffNow: 'Obtenez 25% de remise dès maintenant!',
  youWillBeRedirected:
    'vous serez redirigé(e) vers la page d’optimisation dans',
  seconds: 'secondes',
  aNewMember: "En tant que nouveau membre, vous bénéficiez d'un(e)",
  get: 'Obtenez',
  initialOff: '25% de remise',
  selectedMembership: "l'abonnement que vous avez choisi",
  selectYourMembership: "Sélectionnez votre option d'abonnement",
  newPrice: 'Nouveau prix',
  oldPrice: 'Ancien prix',
  iDontWantToPayLess: 'Non merci, je ne veux pas payer moins.',
  addPhotoOnboarding: 'Ajouter une photo',
  uploadAnotherPhoto: 'Téléverser une autre photo',
  finish: 'Finir',
  ifYourDoneUploadingPhotos: 'Si vous avez fini de téléverser des photos',
  // california
  CCPATitle: 'Ne vendez pas mes renseignements personnels',
  CCPAPersonal: 'Mes informations personnelles',
  youHaveAlreadyOptedOut: 'Vous avez déjà choisi de ne pas y participer.',
  // TransactionProgress
  transactionProgress: 'Transaction en cours',
  checkingSpecialOffers: 'Consultation des offres spéciales...',
  initializingTransaction: 'Initialisation de la transaction...',
  // SpecialOffer
  congratulationsSpecialOffer: 'Félicitations!',
  youAreQualified: 'Vous vous êtes qualifié(e) pour une offre spéciale!',
  toAcceptThisOffer:
    'Pour accepter cette offre, cliquez sur Continuer ci-dessous:',
  noThanksIDontWant: 'Non merci, je ne veux pas payer moins.',
  forYourConvenience: 'Pour vous faciliter la tâche, vous serez facturé(e)',
  on: 'le',
  andEvery: 'et tous les',
  daysThereafter: "jours par la suite, sauf en cas d'annulation.",
  off: 'fermer',
  yourSelectedMembership: "l'abonnement que vous avez choisi.",
  // Transaction Declined
  transactionDeclined: 'Transaction refusée',
  yourCreditCardWasNotApproved:
    "Votre carte de crédit n'a pas été approuvée pour notre offre spéciale d'abonnement.",
  butWait: 'Mais CE N’EST PAS TOUT... voici une autre offre spéciale',
  tryA: 'Essayez-le',
  forOnly: 'pour seulement',
  acceptOffer: "Accepter l'offre",
  membership: 'Abonnement',
  // Measure System
  measureSystem: 'Système de mesure',
  imperial: 'Impérial',
  metric: 'Métrique',
  // kink cam banner
  viewNow: 'Consultez maintenant',
  youGotAFree: 'Vous avez obtenu un gratuit',
  // receipt page
  bonusMembership: 'Abonnement bonus',
  membersLoginArea: 'Zone de connexion des membres',
  // language
  language: 'Langue',
  // OneClick
  signInFromReferal: 'Connectez-vous avec votre profil du site référent',
  siteWouldLikeToAccess:
    config.TITLE +
    ' aimerait avoir accès aux informations suivantes pour vous inscrire sur ce site:',
  permissionsToAccess:
    'le prénom, l’adresse e-mail, la date de naissance, la localisation et les données du profil de base',
  iConsentToDetailsAndRegister:
    "Je consens à ce que ces données soient utilisées pour enregistrer mon profil et je confirme que je suis d'accord avec ",
  allow: 'Autoriser',
  byClickingAllow:
    'En cliquant sur AUTORISER, vous consentez à ce que ces données soient utilisées par ' +
    config.TITLE +
    ' pour vous inscrire sur le site de rencontres et vous confirmez que vous acceptez les conditions générales indiquées ci-dessous. Vous pouvez également utiliser notre ',
  standardRegistrationForm: "formulaire d'inscription standard",
  // SpecialOffer2x
  getFreeMembership: 'Obtenez une adhésion GRATUITE à {0}',
  doubleYourChances: "Doublez vos chances de rencontrer quelqu'un",
  weHavePartnered:
    'Nous nous sommes associés à {0} pour aider nos membres à augmenter leurs chances de trouver une correspondance. Une fois que vous aurez cliqué sur le bouton ci-dessus, nous créerons automatiquement un PROFIL 100% GRATUIT à {0} et vous redirigerons vers la zone des membres, afin que vous puissiez commencer à rechercher dans leur base de données des correspondances potentielles.',
  congratulationsYouGotFree:
    'Félicitations, vous avez obtenu un abonnement GRATUIT à {site_name}.',
  toGetLoggedInto: ' pour vous connecter au site.',
  // RefundCreditCard
  refundCreditCard: 'Remboursement avec une nouvelle carte de crédit',
  refundCreditCardSuccess:
    'Votre demande de remboursement a été soumise avec succès.',
  // Nearby Connect
  nearbyConnect: 'Connexion à proximité',
  nearbyDecline:
    "Non merci, je ne veux pas l'envoyer maintenant, je le ferai plus tard.",
  introduceMyself: 'Me présenter',
  distance: 'Distance',
  anyDistance: 'Toute distance',
  message: 'Message',
  sentByNearbyConnect: 'envoyé par ConnexionProximité',
  typeYourMessageHere: 'Tapez votre message ici',
  sendThisToMyNewMatches:
    "Envoyez également ceci à tous les nouveaux matchs à mesure qu'ils rejoignent",
  successNearbyConnect:
    'Vous avez configuré avec succès la connexion à proximité',
  nearbyConnectTitle:
    'Entrez en contact avec des centaines de membres tout de suite! Seuls les utilisateurs qui correspondent à votre profil recevront ces messages. Saisissez votre message ci-dessous pour commencer:',
  nearbyConnectAlert:
    "Les messages de connexion à proximité sont des messages uniques d'autres membres réels qui pourraient être votre partenaire idéal. Ces messages sont automatiquement envoyés uniquement aux utilisateurs qui correspondent à ce profil d'utilisateur",
  nearbyUnavailable:
    "Désolé, la fonctionnalité NearConnect n'est pas disponible pour le moment. Cette fonctionnalité peut être utilisée une fois tous les 30 jours. Merci pour votre compréhension.",
  nearbyFeatureUsed:
    'Vous avez utilisé la fonctionnalité NearConnect sur {date}.',
  toKeepNearbyFree:
    'Pour garder le NearConnect gratuit, nous le limitons à une seule introduction tous les 30 jours.',
  ifYouLikeToBeIntroduced:
    'Si vous souhaitez être présenté à plus de membres, revenez à {date}.',
  nearbyConnectValentineTitle: 'Spécial Saint-Valentin',
  nearbyConnectValentineText1:
    "La Saint-Valentin approche. Pour une durée limitée, nous vous permettons d'envoyer un ",
  nearbyConnectValentineText2: 'Message de présentation GRATUIT ',
  nearbyConnectValentineText3:
    "à des centaines d'utilisateurs qui correspondent à vos préférences. Entrez simplement votre message ci-dessous pour commencer :",
  // subscription status
  subscriptionStatus: "Statut de l'abonnement",
  subscritpionStatusManageLink1:
    'Félicitations! Vous êtes un membre VIP. Veuillez visiter ',
  subscritpionStatusManageLink2: ' pour gérer votre abonnement.',
  subscriptionUpgradeLink1: 'Vous êtes un membre de base. ',
  subscriptionUpgradeLink2: ' Passez à VIP maintenant!',
  // Manage Nearby Connects
  manageNearbyConnects: 'Gérer la connexion à proximité',
  sendNewNearbyConnectMessage: 'Envoyer un nouveau message NearConnect',
  activeUntil: "Actif jusqu'à",
  sendToNewJoins: 'Envoyer aux nouveaux membres',
  update: 'Mise à jour',
  disable: 'Désactiver',
  nearbyConnectUpdated: 'Connexion à proximité mise à jour avec succès',
  nearbyConnectWillBeAvailable:
    'À proximité Connect sera disponible pour vous la prochaine fois sur ',
  canChangeMessageOn: 'Peut changer de message sur',
  getInTouchWith:
    'Entrez en contact avec des centaines de membres immédiatement ! Seuls les utilisateurs correspondant à votre profil recevront ces messages.',
  cookieConsentText:
    "Le site utilise des cookies. En continuant à naviguer sur le site vous acceptez explicitement l'utilisation de cookies.",
  cookieConsentDetailsLinkText: 'Détails',
  cookieConsentButtonText: 'Je comprends',
  cookieConsentDeclineButtonText: 'fermer',
};



// WEBPACK FOOTER //
// ./src/assets/localization/fr.js